import configHandler from '../../configHandler'
import svHandler from './OrganizationNumberSv'
import noHandler from './OrganizationNumberNo'

const parse = (inputNumber) => {
    let handler
    switch (configHandler.regionKey) {
        case 'sv':
            handler = svHandler(inputNumber)
            break
        case 'no':
        default:
            handler = noHandler(inputNumber)
    }

    handler.parsed = function () {
        return String(handler.input === null ? '' : handler.input)
            .replace(/ /g, '')
            .replace(/-/g, '')
            .replace(/\./g, '')
    }

    return handler
}

export default {
    parse,
}